import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { APIService } from '../shared/service/api.service';

@Component({
  selector: 'app-sugestoes-cnct',
  templateUrl: './sugestoes-cnct.component.html',
  styleUrls: ['./sugestoes-cnct.component.scss']
})
export class SugestoesCnctComponent implements OnInit {
  formulario: FormGroup;
  localAlteracao: string[];
  camposCurso: { label: string; fields: any; checkbox: string }[];

  cursos: {};
  areasTecnologicas: any;
  eixos: any;
  textoTermo: string;

  display: string[] = [];
  regexEmail: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  formErro = false;
  mostarPopUp = false;
  erro = false;

  enviouFormulario = false;
  formularioRecebido = false;
  resposta;

  constructor(private api: APIService) {}

  ngOnInit(): void {
    this.api.getEixosCNCT().subscribe(response => {
      this.eixos = response;
    });

    this.gerarFormulario();

    this.formulario.get('eixoTecnologicoCnctId').valueChanges.subscribe(value => {
      if (value){
        this.api.getCursosEixoCNCT(value).subscribe(response => {
          this.cursos = response;
        });
      }
    });
  }

  gerarFormulario(): void {
    this.formulario = new FormGroup({
      nome: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.pattern(this.regexEmail)]),
      instituicaoEmpresa: new FormControl(null),
      eixoTecnologicoCnctId: new FormControl('', Validators.required),
      sugestaoPara: new FormControl(
        'Alteração de carga horária mínima presencial',
        Validators.required
      ),

      cursoCnctId: new FormControl('', Validators.required),

      propostaCargaHoraria: new FormControl(null, [Validators.required, Validators.maxLength(1000)]),
      justificativaCargaHoraria: new FormControl(null, [Validators.required, Validators.maxLength(1000)]),

      aceitaTermo: new FormControl(false, Validators.requiredTrue),
      reCaptcha: new FormControl(null, [Validators.required]),
    });
  }

  cancelar() {
    if (this.formularioRecebido){
      window.location.reload();
      return;
    }
    this.mostarPopUp = false;
  }

  onSubimitFormulario(): void {
    this.erro = false;
    this.formErro = false;
    this.enviouFormulario = true;

    if (this.formulario.invalid) {
      this.formulario.markAllAsTouched();
      this.formErro = true;
      setTimeout(() => {
        this.enviouFormulario = false;
      }, 200);
      return;
    }

    const url = window.location.href;
    const form = { ...this.formulario.value, linkFormulario: url };
    this.mostarPopUp = true;

    this.api.postFormCNCT(form).subscribe(response => {
      setTimeout(() => {
        this.resposta = response;
        this.formulario.reset();
        this.formularioRecebido = true;
      }, 300);
    },
      (error) => {
        this.erro = true;
      }
    );

  }

}
